export const SET_MENU = 'SET_MENU'
export const SET_META = 'SET_META'
